import React from 'react'
import {
  Base,
  ErrorIcon,
  MagnifyingGlassIcon,
  SuccessIcon
} from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import { ReviewStatus } from '@/domain/review'

interface ItemStatusProps {
  status: ReviewStatus
}

const TONES: Record<ReviewStatus, 'success' | 'warning' | 'danger' | 'info'> = {
  APPROVED: 'success',
  MISSING: 'warning',
  DECLINED: 'danger',
  PENDING: 'info'
}

const ICONS: Partial<Record<ReviewStatus, React.ReactNode>> = {
  APPROVED: <SuccessIcon color="currentColor" />,
  MISSING: <MagnifyingGlassIcon color="currentColor" />,
  DECLINED: <ErrorIcon color="currentColor" />
}

const ItemStatus: React.FC<ItemStatusProps> = ({ status }) => {
  const { t } = useTranslation()

  return (
    <Base.Badge tone={TONES[status]} icon={ICONS[status]}>
      {t(`line_item_review_status.${status}`)}
    </Base.Badge>
  )
}

export default ItemStatus
